/** @jsx jsx */
import React from 'react';
import FormContents from 'components/atoms/Form/FormContents';
import { css, jsx } from '@emotion/core';
import TabControl from 'components/atoms/TabControl';
import StaffCsvImportPage from './StaffCsvImportPage';
import StaffCsvHistory from './StaffCsvHistory';
import FormHeader from 'components/templates/FormHeader';

export type UploadType = '0' | '1' | '2';

type SelectType = "import" | "history";

const SelectType: { [key in SelectType]: SelectType } = {
  import: "import",
  history: "history",
};

const StaffCsvUploadForm: React.FC = () => {

  const [selectType, setSelectType] = React.useState<SelectType>(
    SelectType.import
  );
  return (
    <div>
    <FormHeader title="スタッフインポート" />
    <FormContents customStyle={css({marginTop:'60px'})}>
      <TabControl
        items={[
          {
            value: SelectType.import,
            display: "インポート",
          },
          {
            value: SelectType.history,
            display: "履歴参照",
          },
        ]}
        setValue={setSelectType as (arg: string) => void}
        currentValue={selectType}
        customStyle={css({paddingTop:'15px'})}
      />
      <div>
        { selectType === 'import' ? <StaffCsvImportPage/> : <StaffCsvHistory /> }
      </div>
    </FormContents>
    </div>
  
 );
};

export default StaffCsvUploadForm;
